import { render, staticRenderFns } from "./latestPositions.vue?vue&type=template&id=0599d9d9&scoped=true&"
import script from "./latestPositions.vue?vue&type=script&lang=js&"
export * from "./latestPositions.vue?vue&type=script&lang=js&"
import style0 from "./latestPositions.vue?vue&type=style&index=0&id=0599d9d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0599d9d9",
  null
  
)

export default component.exports